import React from 'react';

export interface KillSwitchBannerProps {
  message?: string;
}

const DEFAULT_MESSAGE =
  'Agent writes are currently disabled. Existing drafts are preserved but no new drafts can be created.';

export const KillSwitchBanner: React.FC<KillSwitchBannerProps> = ({
  message = DEFAULT_MESSAGE,
}) => (
  <div
    role="status"
    style={{
      background: 'var(--warning-subtle, #fffbeb)',
      color: 'var(--warning-foreground, #b45309)',
      padding: '8px 12px',
      borderRadius: 6,
      fontSize: 14,
      margin: '8px 12px',
    }}
  >
    {message}
  </div>
);
